import Money from '../dto/Money';

export default class PriceFormatter {
    format(price, currencyAsSymbol = false) {
        const data = {
            currency: price.currency,
            amount: { numerator: price.gross.numerator, denominator: price.gross.denominator },
        };

        return `${Money.fromData(data).toLocalizedString()} ${
            !currencyAsSymbol ? price.currency : this.getCurrencySymbol(price.currency)}`;
    }

    formatFromNumber(price) {
        return `${Money.fromNumber(price.amount).toLocalizedString()} ${price.currency}`;
    }

    formatWithQuantityFactor(price, quantityFactor) {
        const data = {
            currency: price.currency,
            amount: {
                numerator: price.gross.numerator * quantityFactor.numerator,
                denominator: price.gross.denominator * quantityFactor.denominator,
            },
        };

        return `${Money.fromData(data).toLocalizedString()} ${price.currency}`;
    }

    formatFromNumberWithQuantityFactor(price) {
        return `${Money.fromNumber(price.amount).toLocalizedString()} ${price.currency}`;
    }

    getVat(price, decimals = 0) {
        return (price.vat.numerator / (price.vat.denominator / 100)).toFixed(decimals);
    }

    getCurrencySymbol(currency) {
        if (currency === 'USD') {
            return '$';
        }
        return '€';
    }
}
